<template>
  <div
    class="flex flex-col justify-between bg-light-grey p-5 rounded-xl overflow-hidden"
  >
    <div class="flex flex-col flex-1 overflow-hidden">
      <h2 class="text-lg text-primary-900 mb-5">
        {{ $t("home.latest_internal_conversations") }}
      </h2>
      <div
        v-if="conversations.length === 0"
        class="flex flex-col flex-1 justify-center items-center h-full"
      >
        <p class="text-primary-900 text-sm">
          {{ $t("home.no_internal_conversations") }}
        </p>
      </div>
      <div v-else class="flex flex-col flex-1 overflow-y-auto">
        <div
          v-for="item in conversations"
          :key="item.uname"
          class="flex justify-between items-center bg-white p-4 mb-3 rounded-xl w-full"
        >
          <div class="flex items-center gap-3">
            <Avatar
              class="bg-primary-100"
              :image="item.avatar ? item.avatar : null"
              shape="circle"
              size="xlarge"
            />
            <div>
              <p class="text-primary-900 text-sm">
                {{ item.fullname }}
              </p>
              <p class="text-primary-900 text-sm mt-1">
                {{ item.last_message }}
              </p>
              <div class="flex items-center gap-1 mt-2 text-xs">
                <v-icon class="text-primary-500">mdi-clock-outline</v-icon>
                <p class="text-primary-500">
                  {{ getConversationTime(item.last_time) }}
                </p>
              </div>
            </div>
          </div>
          <RouterLink
            class="hover:bg-primary-900 bg-light-grey rounded-full p-2"
            :to="`${getbaseURL}/Chat/${item.uname}`"
            rounded
          >
            <v-icon class="text-primary-500 text-3xl hover:!text-white">{{
              "mdi-eye-outline"
            }}</v-icon></RouterLink
          >
        </div>
      </div>
    </div>
    <div class="flex justify-center" v-if="conversations.length > 0">
      <Button
        class="bg-white hover:!bg-primary-900 hover:!text-white px-5 py-3 mt-4 rounded-lg text-primary-900 border-solid border-primary-900 border"
        :label="$t('home.show_all')"
        @click="GoToConversations"
      />
    </div>
  </div>
</template>

<script>
import { Button, Avatar } from "primevue";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  components: { Button, Avatar },
  data() {
    return {
      isInit: false,
      usersList: [],
      conversations: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["getbaseURL"]),
    currentLocal() {
      return this.$vuetify.locale.current;
    },
  },
  async created() {
    await this.initChat();
  },
  methods: {
    GoToConversations() {
      this.$router.push(`${this.getbaseURL}/Chat/`);
    },
    async initChat() {
      if (this.isInit) {
        return;
      }
      this.isInit = true;
      this.loading = true;
      try {
        const userResp = await this.GetChatUsers();
        if (!userResp.success) {
          this.loading = false;
          this.SetMessageDialog({ show: true, message: userResp.message });
          return;
        }
        this.usersList = userResp.users;
        const conversResp = await this.GetUserConversations();
        if (!conversResp.success) {
          this.loading = false;
          this.SetMessageDialog({ show: true, message: conversResp.message });
          return;
        }
        const result = conversResp.conversations;
        const initConversations = [];
        for (const res of result) {
          const user = this.usersList.find((usr) => usr.uname == res.uname);
          const converse = { ...res, ...user, isSet: res.messages.length > 0 };
          initConversations.push(converse);
        }
        this.conversations = initConversations;
        this.loading = false;
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.loading = false;
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    getConversationTime(lastTime, type) {
      const messageDay = moment.unix(+lastTime).format("YYYY-MM-DD");
      const today = moment().format("YYYY-MM-DD");
      const sameDayCond = moment(messageDay).isSame(moment(today), "day");
      if (sameDayCond && type != 3) {
        return moment.unix(+lastTime).format("HH:mm");
      } else if (sameDayCond && type == 3) {
        return this.$t("chat.time.today");
      }
      if (moment(today).diff(moment(messageDay), "days") == 1) {
        return this.$t("chat.time.yesterday");
      }
      const weekEarlier = moment().add(-7, "days").format("YYYY-MM-DD");
      if (moment(weekEarlier).isBefore(moment(messageDay))) {
        return moment.unix(+lastTime).locale(this.currentLocal).format("dddd");
      }
      return messageDay;
    },
    ...mapActions([
      "GetUserConversations",
      "GetChatUsers",
      "GetChatConversationMessages",
      "ShowProgressBar",
      "SetMessageDialog",
    ]),
  },
};
</script>

<style></style>
